import React from "react";
import Instagram from "../resources/vectors/Instagram.svg";
// import Facebook from "../resources/vectors/Facebook.svg";
import Linkedin from "../resources/vectors/Linkedin.svg";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer id="Footer" className="relative mt-5 block ">
    <div className="z-0 absolute h-full w-full overflow-hidden opacity-80 absolute top-0 left-0">
      <svg className="absolute" height="2" width="333" id="line1">
        <line x1="0" y1="0" x2="333" y2="0" stroke="#DB4437" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="250" width="2" id="line2">
        <line x1="0" y1="0" x2="0" y2="250" stroke="#0F9D58" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="2" width="333" id="line3">
        <line x1="0" y1="0" x2="333" y2="0" stroke="#DB4437" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="269" width="2" id="line4">
        <line x1="0" y1="0" x2="0" y2="269" stroke="#FCCA3E" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="2" width="333" id="line5">
        <line x1="0" y1="0" x2="333" y2="0" stroke="#DB4437" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="213" width="2" id="line6">
        <line x1="0" y1="0" x2="0" y2="213" stroke="#0F9D58" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="2" width="1072" id="line7">
        <line x1="0" y1="0" x2="1072" y2="0" stroke="#DB4437" strokeWidth="2" />
      </svg>
      <svg className="absolute" height="250" width="2" id="line8">
        <line x1="0" y1="0" x2="0" y2="250" stroke="#4285F4" strokeWidth="2" />
      </svg>
    </div>
    <div className="grid relative grid-cols-1 lg:grid-cols-7 gap-5 justify-items-center text-white py-20 lg:px-40 md:px-20 px-10 z-10">
      <div className="col-span-3 text-3xl lg:text-4xl w-full">
        <h1 className="font-bold">JOIN</h1>
        <h1 className="py-3">The</h1>
        <h1 className="font-bold">AMAZING</h1>
        <h1 className="py-3">Group of</h1>
        <h1 className="font-bold">YOUNG DEVELOPERS</h1>
      </div>
      <div className="col-span-2 text-xl lg:text-2xl w-full">
        <h3>Feel free to contact us</h3>
        <button id="SubscribeButton" className="rounded-full px-3">
          <Link to="/contact">
            <h4 className="text-xl">Contact</h4>
          </Link>
        </button>
      </div>
      <div className="col-span-2 text-xl lg:text-2xl w-full">
        <h3>Follow us on:</h3>
        <div className="grid grid-cols-3 w-max">
          <a href="https://www.instagram.com/dsc_aissmscoe/" target="_blank" rel="noopener noreferrer">
            <img src={Instagram} alt="Instagram" width="40px" />
          </a>
          {/* <a href="#" target="_blank">
            <img src={Facebook} alt="Facebook" width="40px" />
          </a> */}
          <a
            href="https://in.linkedin.com/company/dsc-aissmscoe-pune/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Linkedin} alt="Linkedin" width="40px" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
